(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("learningPathResource", ["$resource", learningPathResource]);
    function learningPathResource($resource) {
        return $resource("/api/learningPaths/:number/:languageCulture/:action/:actionValue", { action: "@action", number: "@number", languageCulture: "@languageCulture", actionValue: "@actionValue" }, {
            getAvailablePaths: {
                method: "GET",
                params: { action: "available" },
                isArray: true
            },
            getPublishedPaths: {
                method: "GET",
                params: { action: "published" },
                isArray: true
            },
            getVisibilityWizardList: {
                method: "GET",
                params: { action: "visibilityWizard" },
                isArray: true
            },
            saveVisibilityWizard: {
                method: "POST",
                params: { action: "visibilityWizard" }
            },
            getList: {
                method: "GET",
                isArray: true
            },
            getIsNameAvailable: {
                method: "GET",
                params: { action: "isAvailable" }
            },
            getTranslations: {
                method: "GET",
                params: { action: "translation" }
            },
            saveTranslations: {
                method: "POST",
                params: { action: "translation" }
            },
            savePathIcon: {
                method: "PUT",
                params: { action: "pathIcon" }
            },
            getCropData: {
                method: "GET",
                params: { action: "getCropDataViewModel" }
            },
            savePicture: {
                method: "POST",
                params: { action: "savePicture" }
            },
            createProduct: {
                method: "POST",
                params: { action: "product" }
            }
        });
    }
}());
